/* =============================================================================
   Casa Punto — theme interactions (vanilla JS, no deps)
   Drawers, scroll-reveal, tabs, quantity, gallery thumbs, carousel nav.
   Product data comes from Liquid, so there is no card generator here.
   ============================================================================= */
(function () {
  'use strict';

  var overlay = function () { return document.querySelector('[data-overlay]'); };
  function closeAll() {
    document.querySelectorAll('.nav-drawer.is-open, .cart-drawer.is-open, .filter-drawer.is-open, .search-panel.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    var o = overlay(); if (o) o.classList.remove('is-open');
    document.querySelectorAll('.popup').forEach(function (p) { p.classList.add('u-hidden'); });
    document.body.style.overflow = '';
  }
  function open(id) {
    var map = { nav: '#nav-drawer', cart: '#cart-drawer', filter: '#filter-drawer', search: '#search-overlay', popup: '#welcome-popup' };
    var el = document.querySelector(map[id]); if (!el) return;
    if (id === 'popup') { el.classList.remove('u-hidden'); return; }
    el.classList.add('is-open');
    var o = overlay(); if (o) o.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (id === 'search') { var i = el.querySelector('[data-search-input]'); if (i) setTimeout(function(){ i.focus(); }, 60); }
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); open(opener.getAttribute('data-open')); return; }
    if (e.target.closest('[data-close]') || e.target.matches('[data-overlay]')) closeAll();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* Tabs (cosmetic) */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.tab'); if (!tab) return;
    var group = tab.closest('.tabs'); if (!group) return;
    group.querySelectorAll('.tab').forEach(function (t) { t.classList.remove('is-active'); });
    tab.classList.add('is-active');
  });

  /* Exclusive accordions — only one <details> open per .accordion group */
  document.addEventListener('toggle', function (e) {
    var item = e.target;
    if (!item.matches || !item.matches('.accordion__item') || !item.open) return;
    var group = item.closest('.accordion'); if (!group) return;
    group.querySelectorAll('.accordion__item[open]').forEach(function (d) { if (d !== item) d.open = false; });
  }, true);

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty__btn'); if (!btn) return;
    var input = btn.parentElement.querySelector('.qty__input'); if (!input) return;
    var v = parseInt(input.value || '1', 10);
    v += (btn.textContent.trim() === '+' ? 1 : -1);
    input.value = Math.max(1, v);
    if (input.form) input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* PDP gallery — swipeable carousel synced with dots + thumbs */
  function gallery() {
    var stage = document.querySelector('[data-gallery-stage]'); if (!stage) return;
    var slides = [].slice.call(stage.querySelectorAll('.pdp__slide'));
    var dots = [].slice.call(document.querySelectorAll('[data-gallery-dots] [data-dot]'));
    var thumbs = [].slice.call(document.querySelectorAll('.pdp__thumbs [data-thumb]'));
    if (slides.length < 2) return;
    function setActive(i) {
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
    }
    function goTo(i) { var s = slides[i]; if (s) stage.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { var i = +t.getAttribute('data-thumb'); goTo(i); setActive(i); }); });
    dots.forEach(function (d) { d.addEventListener('click', function () { var i = +d.getAttribute('data-dot'); goTo(i); setActive(i); }); });
    var raf;
    stage.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var center = stage.scrollLeft + stage.clientWidth / 2, best = 0, bestD = Infinity;
        slides.forEach(function (s, i) { var c = s.offsetLeft + s.clientWidth / 2; var d = Math.abs(c - center); if (d < bestD) { bestD = d; best = i; } });
        setActive(best);
      });
    }, { passive: true });
  }

  /* Carousel nav */
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-carousel-prev]');
    var next = e.target.closest('[data-carousel-next]');
    if (!prev && !next) return;
    var wrap = (prev || next).closest('.carousel');
    var track = wrap && wrap.querySelector('.carousel__track'); if (!track) return;
    var first = track.firstElementChild;
    var step = first ? first.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    track.scrollBy({ left: (next ? 1 : -1) * step * 2, behavior: 'smooth' });
  });

  /* Reveal on scroll */
  function observeReveals() {
    var els = document.querySelectorAll('.reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function headerScroll() {
    var h = document.querySelector('[data-header]'); if (!h) return;
    var on = function () { h.classList.toggle('is-scrolled', window.scrollY > 4); };
    on(); window.addEventListener('scroll', on, { passive: true });
  }

  function stickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]'); if (!bar) return;
    var main = document.querySelector('.buybox [data-add]');
    if (!main || !('IntersectionObserver' in window)) { return; }
    var mainAbove = false, footerVisible = false;
    function apply() { bar.classList.toggle('is-visible', mainAbove && !footerVisible); }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { mainAbove = !e.isIntersecting && e.boundingClientRect.top < 0; });
      apply();
    }, { threshold: 0 }).observe(main);
    var footer = document.querySelector('.footer');
    if (footer) new IntersectionObserver(function (es) {
      es.forEach(function (e) { footerVisible = e.isIntersecting; });
      apply();
    }, { threshold: 0 }).observe(footer);
  }

  /* ---------------------------------------------------------------------------
     AJAX cart — add-to-cart opens the side drawer instead of the /cart page,
     and qty/remove inside the drawer update in place via the Sections API.
  --------------------------------------------------------------------------- */
  function updateCartCount(n) {
    var btn = document.querySelector('.header__cart'); if (!btn) return;
    var badge = btn.querySelector('.header__count');
    if (n > 0) { if (!badge) { badge = document.createElement('span'); badge.className = 'header__count'; btn.appendChild(badge); } badge.textContent = n; }
    else if (badge) { badge.remove(); }
  }
  function renderCartDrawer(html) {
    if (!html) return;
    var tmp = document.createElement('div'); tmp.innerHTML = html.trim();
    var fresh = tmp.querySelector('#cart-drawer'); var cur = document.querySelector('#cart-drawer');
    if (!fresh || !cur) return;
    var wasOpen = cur.classList.contains('is-open');
    cur.replaceWith(fresh);
    if (wasOpen) fresh.classList.add('is-open');
    updateCartCount(parseInt(fresh.getAttribute('data-cart-count') || '0', 10));
  }
  function cartPost(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }

  /* Add to cart from the product form (also covers the sticky bar via form=) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#product-form'); if (!form) return;
    e.preventDefault();
    var idEl = form.querySelector('[data-variant-id]'); var id = idEl && idEl.value;
    if (!id) { form.submit(); return; }
    var btns = [].slice.call(document.querySelectorAll('[data-add]'));
    btns.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
    cartPost('/cart/add.js', { items: [{ id: id, quantity: 1 }], sections: ['cart-drawer'] })
      .then(function (data) {
        if (data && data.sections) renderCartDrawer(data.sections['cart-drawer']);
        open('cart');
      })
      .catch(function () { form.submit(); })
      .then(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); }); });
  });

  /* Qty +/- and remove inside the drawer */
  document.addEventListener('click', function (e) {
    var ctl = e.target.closest('[data-line][data-change]'); if (!ctl) return;
    e.preventDefault();
    var drawer = document.querySelector('#cart-drawer'); if (drawer) drawer.classList.add('is-busy');
    cartPost('/cart/change.js', { line: parseInt(ctl.getAttribute('data-line'), 10), quantity: parseInt(ctl.getAttribute('data-change'), 10), sections: ['cart-drawer'] })
      .then(function (data) { if (data && data.sections) renderCartDrawer(data.sections['cart-drawer']); });
  });

  /* Predictive search — live results from Shopify's suggest.json */
  function predictiveSearch() {
    var input = document.querySelector('[data-search-input]');
    var out = document.querySelector('[data-search-results]');
    if (!input || !out) return;
    var defaultHTML = out.innerHTML;
    var timer, controller;
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function money(v) { var n = parseFloat(v); if (isNaN(n)) return esc(v); try { return n.toLocaleString('es-ES', { style: 'currency', currency: cur }); } catch (e) { return n.toFixed(2); } }
    function render(data, q) {
      var res = data && data.resources && data.resources.results ? data.resources.results : {};
      var products = res.products || [];
      if (!products.length) {
        out.innerHTML = '<div class="search-empty">No encontramos resultados para <b>' + esc(q) + '</b>.</div>';
        return;
      }
      var html = '<div class="search-hits">';
      products.forEach(function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        html += '<a class="search-hit" href="' + p.url + '" data-close>' +
          '<span class="search-hit__media">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span class="ph"></span>') + '</span>' +
          '<span class="search-hit__info"><span class="search-hit__title">' + esc(p.title) + '</span>' +
          (p.price ? '<span class="search-hit__price">' + money(p.price) + '</span>' : '') + '</span></a>';
      });
      html += '</div><a class="search-all" href="/search?q=' + encodeURIComponent(q) + '" data-close>Ver todos los resultados</a>';
      out.innerHTML = html;
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { out.innerHTML = defaultHTML; return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = ('AbortController' in window) ? new AbortController() : null;
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, controller ? { signal: controller.signal } : undefined)
          .then(function (r) { return r.json(); })
          .then(function (d) { render(d, q); })
          .catch(function () {});
      }, 220);
    });
  }

  function init() { observeReveals(); headerScroll(); stickyAtc(); gallery(); predictiveSearch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
